module.exports = __webpack_public_path__ + "static/media/ricardo-perez-provider.87309579.svg";